import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import './Chart.BasicDoughnut';
import React from 'react';
import ChartComponent from 'react-chartjs-2';
import { getData, resolveOptions } from '../utils';
import { ChartContainer, Container } from '../styled-components';
export var BasicDoughnut = function BasicDoughnut(_ref) {
  var data = _ref.data,
      className = _ref.className,
      colors = _ref.colors,
      onItemHighlight = _ref.onItemHighlight,
      options = _ref.options,
      children = _ref.children,
      dataCallback = _ref.dataCallback,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '270px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '270px' : _ref$height,
      dashedBorder = _ref.dashedBorder,
      props = _objectWithoutProperties(_ref, ["data", "className", "colors", "onItemHighlight", "options", "children", "dataCallback", "width", "height", "dashedBorder"]);

  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(ChartContainer, {
    dashedBorder: dashedBorder,
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement(ChartComponent, _extends({
    type: 'basic',
    data: dataCallback ? dataCallback : getData(data, colors),
    options: resolveOptions(onItemHighlight, false, false, options)
  }, props))), children);
};